/*
 * Public API for the site layer.
 *
 * Application code imports ONLY from `@/site` — never from
 * `@/site/sites/<id>` (an ESLint rule enforces this).
 */

export { site, fonts } from './active'
export type * from './types'
